import { MuiTheme, createStyles, makeStyles } from '@kis-technologies/kis-ui';

export const useStyles = (props: { width: number; height: number | undefined }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      actionOverlayContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        width: props.width ? props.width : 700,
        height: props.height ? props.height : 500,
        background: 'white',
        color: '#2A2A2A',
        boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
        borderRadius: '8px',
        padding: '40px 0px 0px 0px',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.only('sm')]: {
          width: '550px',
          height: '375px'
        },
        [theme.breakpoints.only('xs')]: {
          height: '265px'
        }
      },
      actionOverlayTitle: {
        flex: 'none',
        background: 'transparent',
        margin: '0px 104px 0px 104px',
        [theme.breakpoints.down('sm')]: {
          margin: '0px 10px 0px 10px'
        }
      },
      actionOverlayButtons: {
        width: props.width * 0.4,
        minWidth: '300px',
        [theme.breakpoints.down('sm')]: {
          width: '145px',
          minWidth: '150px',
          fontSize: '18px'
        }
      }
    })
  );
